import React from 'react';
import { Coffee, Award, Heart, Leaf } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen pt-44 pb-16">
      <div className="container mx-auto px-4">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6" data-testid="about-title">
            JUNTO® Hakkında
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Kahve tutkusu ile başlayan hikayemiz, her fincanı özel kılan kalite anlayışımızla devam ediyor.
          </p>
        </div>

        {/* Story Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Hikayemiz</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                JUNTO®, kahve severlerin bir araya geldiği ve kaliteli kahvenin tadını çıkardığı bir markadır. 
                2020 yılında kurulan markamız, dünya çapında en iyi kahve çekirdeklerini seçerek sizlere 
                sunma vizyonuyla yola çıktı.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Brezilya'dan Kolombiya'ya, Guatemala'dan Hindistan'a kadar dünyanın en özel kahve bölgelerinden 
                özenle seçtiğimiz çekirdekleri, taze kavrum tekniklerimizle işliyor ve her fincanın mükemmel 
                olması için çalışıyoruz.
              </p>
              <p className="text-gray-700 leading-relaxed">
                JUNTO® olarak, sadece kahve satmıyoruz; bir yaşam tarzı, bir tutku ve bir topluluk yaratıyoruz.
              </p>
            </div>
            <div>
              <img 
                src="https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=800" 
                alt="JUNTO Kahve" 
                className="rounded-xl shadow-lg w-full"
              />
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Değerlerimiz</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition-all">
              <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
                <Award className="w-12 h-12 text-junto-red" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Kalite</h3>
              <p className="text-gray-600">
                En yüksek kalite standartlarında çekirdek seçimi ve kavrum
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition-all">
              <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
                <Coffee className="w-12 h-12 text-junto-red" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Tutku</h3>
              <p className="text-gray-600">
                Kahve sevgimiz her üretim aşamasına yansıyor
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition-all">
              <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
                <Leaf className="w-12 h-12 text-junto-red" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sürdürülebilirlik</h3>
              <p className="text-gray-600">
                Çevreye duyarlı üretim ve etik kaynak sağlama
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-2xl transition-all">
              <div className="inline-block p-4 bg-junto-red/10 rounded-full mb-4">
                <Heart className="w-12 h-12 text-junto-red" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Müşteri Memnuniyeti</h3>
              <p className="text-gray-600">
                Her müşterimize özel ilgi ve kusursuz hizmet
              </p>
            </div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-junto-red to-junto-red-dark text-white rounded-2xl shadow-xl p-8">
            <h2 className="text-3xl font-bold mb-4">Misyonumuz</h2>
            <p className="text-white/90 leading-relaxed">
              Dünya çapında en kaliteli kahve çekirdeklerini özenle seçip, taze kavrum teknikleriyle 
              işleyerek kahve severlere unutulmaz lezzet deneyimleri sunmak. Her fincanın bir hikaye 
              anlatmasını sağlamak.
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-800 to-gray-900 text-white rounded-2xl shadow-xl p-8">
            <h2 className="text-3xl font-bold mb-4">Vizyonumuz</h2>
            <p className="text-white/90 leading-relaxed">
              Türkiye'nin en sevilen ve güvenilen kahve markası olmak. Kahve kültürünü yaygınlaştırarak, 
              her evde JUNTO® kahvesinin bulunduğu bir gelecek yaratmak.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;